

class Navigation {
  constructor() {
    this.triggers = document.querySelectorAll('[data-navitem]');
    this.subnav = document.getElementById('subnav');
    this.button = document.querySelector('.nav__primary--button');
    this.phoneicons = document.querySelectorAll('.nav__primary--phone');
    this.phone = document.querySelector('.nav__phone');
    this.search = document.querySelector('.nav__search');
    this.searchicons = document.querySelectorAll('.nav__primary--search');
    this.mobnav = document.querySelector('.nav__mobile');
    this.dropdowns = document.querySelectorAll('.nav__mobile--hasdropdown');
    this.nzaus = document.querySelectorAll('.menu__nzaus > a, .nav__mobile--nzaus > a, .footer__nav--nzaus > a');
    this.main = document.querySelector('main');
    // Highlight NZ or AUS
    this.domain = location.origin;

    this.highlightCountry();

    this.events();
  }

  events() {
    [...this.triggers].forEach(trigger => {
      trigger.addEventListener('click', this.showSubNav.bind(this));
    });
    [...this.dropdowns].forEach(subnav => {
      subnav.addEventListener('click', this.showMobileSubnav.bind(this));
    })
    this.button.addEventListener('click', this.showMobileNav.bind(this));
    this.main.addEventListener('click', this.pageFunctions.bind(this));
  }

  /**
   * If clicked menu item has a sub-navigation menu,
   * show it
   * @param {Event} e
   */
  showSubNav(e) {
    const link = e.target.closest('.nav__primary--has-dropdown');
    if(link) {
      e.preventDefault();
    } else {
      return;
    }
    const itemid = e.target.dataset.navitem
    if(this.link == link) {
      this.subnav.innerHTML = '';
      this.link = null;
      return;
    }
    this.link = link;
    // Create url with ajax marker
    const url = 'navapi/getsubnav/' + itemid + "?ajax=1";

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html'
      }
    })
    .then(response => response.text())
    .then(content => {
      if (content) {
        this.subnav.innerHTML = content;
      }
    })
  }

  /**
   * Highlight NZ or AUS depending on which country was selected
   */
  highlightCountry() {
    if(this.domain.indexOf('.com.au') > -1) {
        this.nzaus[0].classList.remove('current');
        this.nzaus[1].classList.add('current');
    } else {
        this.nzaus[0].classList.add('current');
        this.nzaus[1].classList.remove('current');
    }
  }

  pageFunctions(e) {
    // close subnav
    if(e.target.closest('main')) {
      this.subnav.innerHTML = '';
    };
  }

  /**
   * Show mobile navigation (screens < 992px)
   * when hamburger menu is clicked or tapped
   * @link /app/templates/Includes/NavMobile.ss
   * @param {Event} e
   */
  showMobileNav(e) {
    e.preventDefault();

    if(this.mobnav.classList.contains('nav__mobile--show')) {
      // Close subnavs before rolling up the mobile nav
      // Prevents bottom of nav covering the screen
      this.dropdowns.forEach(dd => {
        dd.classList.remove('selected');
      });
      this.mobnav.classList.remove('nav__mobile--show');
    } else {
      this.search.classList.remove('nav__search--show');
      this.searchicons.forEach(icon => {
        icon.classList.remove('nav__primary--show');
      })
      this.mobnav.classList.add('nav__mobile--show');
    }
  }

  showMobileSubnav(e) {
    if(e.target.classList.contains('nav__mobile--dropdown-link')) {
      // Prevent default action on link if it is the top level to allow dropdown to open
      e.preventDefault();
    } else if(e.target.tagName == 'A') {
      // Don't close subnav if a link is clicked
      return;
    }

    const tgt = e.target.closest('.nav__mobile--hasdropdown');

    if(tgt.classList.contains('selected')) {
      tgt.classList.remove('selected');
      return;
    }

    this.dropdowns.forEach(dd => {
      dd.classList.remove('selected');
    });

    tgt.classList.add('selected');

  }
}

export default Navigation;
